import React, { ReactNode } from 'react';
import { useAuth } from '../context/AuthContext';

interface PermissionGateProps {
    children: ReactNode;
    /**
     * Kontrol edilecek yetki etiketi (Örn: 'product.delete')
     * Eğer bir array verilirse, 'requireAll' prop'una göre davranış değişir.
     */
    permission: string | string[];
    /**
     * Eğer true ise, verilen yetkilerin HEPSİNE sahip olunmalıdır.
     * Eğer false ise (varsayılan), verilen yetkilerden HERHANGİ BİRİNE sahip olunması yeterlidir.
     */
    requireAll?: boolean;
    /**
     * Yetki yoksa gösterilecek alternatif bileşen (Örn: "Yetkiniz Yok" yazısı veya null)
     * Varsayılan: null (hiçbir şey gösterme)
     */
    fallback?: ReactNode;
}

/**
 * Kullanıcının belirli yetkilere sahip olup olmadığını kontrol eden ve
 * buna göre içeriği gösteren/gizleyen bileşen.
 * 
 * Örnek:
 * <PermissionGate permission="product.create">
 *   <Button>Ürün Ekle</Button>
 * </PermissionGate>
 */
export const PermissionGate: React.FC<PermissionGateProps> = ({
    children,
    permission,
    requireAll = false,
    fallback = null
}) => {
    const { hasPermission, isAuthenticated } = useAuth();

    if (!isAuthenticated) {
        return <>{fallback}</>;
    }

    const permissionsToCheck = Array.isArray(permission) ? permission : [permission];

    if (permissionsToCheck.length === 0) {
        return <>{children}</>;
    }

    const hasAccess = requireAll
        ? permissionsToCheck.every(p => hasPermission(p))
        : permissionsToCheck.some(p => hasPermission(p));

    if (!hasAccess) {
        return <>{fallback}</>;
    }

    return <>{children}</>;
};
